import $ from 'jquery'

export default class Table {
    constructor() {
        var that = this;

        $(document).bind('table-show', function (e, values) {
            that.displayTable(values)
        }).bind(that);

        $(document).bind('table-hide', function (e, data) {
            that.hideTable()
        }).bind(that);
    }

    /**
    * @name displayTable
    * @function
    * @param {values}
    * @description: Display the table
    */
    displayTable(values) {
        let value1 = values[0] ? values[0] : ``,
            value2 = values[1] ? values[1] : ``,
            value3 = values[2] ? values[2] : ``,
            value4 = values[3] ? values[3] : ``,
            value5 = values[4] ? values[4] : ``,
            value6 = values[5] ? values[5] : ``,
            value7 = values[6] ? values[6] : ``,
            value8 = values[7] ? values[7] : ``;
        let body = `
        <table id="fill-table">
            <colgroup>
                <col />
                <col />
                <col style="background-color:#D3D3D3;"/>
            </colgroup>
            <thead><tr><th colspan="3"><b>Notation Table</th></tr></thead>
            <tbody>
                <tr><th>Steps</th><th>White</th><th>Black</th></tr>
                <tr><td>1</td><td class="table-value">${value1}</td><td class="table-value">${value2}</td></tr>
                <tr><td>2</td><td class="table-value">${value3}</td><td class="table-value">${value4}</td></tr>
                <tr><td>3</td><td class="table-value">${value5}</td><td class="table-value">${value6}</td></tr>
                <tr><td>4</td><td class="table-value">${value7}</td><td class="table-value">${value8}</td></tr>
            </tbody>
        </table>`;

        $('.left-box-content').html(body);
    }

    /**
     * @name hideTable
     * @function
     * @param
     * @description: Hide the table
     */
    hideTable() {
        $('#fill-table').remove();
    }
}


// WEBPACK FOOTER //
// ./src/components/table.js